/**
 * All the keys, API endpoints, etc go here.
 */

const config = {
  api: "/api/v1"
  //api: "http://localhost:8000/api/v1"
};

export const api = config.api;

export const apiAthletes = `${api}/athletes/`;

export const apiCategories = `${api}/categories/`;

export const apiVotes = `${api}/votes/`;

export const apiSendVote = `${api}/vote`;

export default config;
